import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
/** Merge Tailwind class names, de-duplicating conflicting utilities. */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
//# sourceMappingURL=utils.js.map